import React, { useEffect, useRef, useState } from 'react'
import api from '../../../api';
import { Dropdown } from 'primereact/dropdown';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  Legend, BarChart, Bar
} from 'recharts';
import { Divider } from 'primereact/divider';
import { ProgressSpinner } from 'primereact/progressspinner';


const Overall = () => {

    const currentDate1 = new Date();
    const formattedCurrentDate = `${currentDate1.getDate().toString().padStart(2, '0')}-${(currentDate1.getMonth() + 1).toString().padStart(2, '0')}-${currentDate1.getFullYear()} ${currentDate1.getHours().toString().padStart(2, '0')}:${currentDate1.getMinutes().toString().padStart(2, '0')}:${currentDate1.getSeconds().toString().padStart(2, '0')}`;
    const userID = sessionStorage.getItem("UserID");
    const roleID = sessionStorage.getItem("RoleID");

    const [loading, setLoading] = useState(false);
    const toast = useRef(null);

    const typeName = [
      { id: "1", label: "Control" },
      { id: "2", label: "Intervention" },
    ];

    const [selectedSite, setSelectedSite] = useState({ site_code: "" });
    const [selectedType, setSelectedType] = useState("");
    const [date, setDate] = useState(null);
    const [date1, setDate1] = useState(null);
    

    const [site, setSite] = useState([]);
    const getSite = async () => {
      try {
        setLoading(true);
        const requestData = {
          logged_in_userid : userID,
          role_id : roleID,
          state_id: "",
          synceddatetime : formattedCurrentDate,
          FormCode : "202",
          ApiKey : "kavin",
          AppTypeNo : "3",
          AppVersion : "1.0.0",
          data_source : "W"
        };
          const result = await api.get_Filter_Site(requestData);
          const sitesData = result.site_admin_details.map((site) => ({
          label: site.fld_site_name,
          value: site.fld_site_name,
          site_code: site.fld_site_id,
          site_swid: site.fld_site_sw_id
        }));

        setSite(sitesData);
      } catch (error) {
        console.error("Error fetching site:", error);
      } finally {
        setLoading(false);
    }
    };

    useEffect(() => {
      getSite();
    }, []);



    const [recruitmentRateData, setRecruitmentRateData] = useState([]);
    const [suicideModuleData, setSuicideModuleData] = useState(0);
    const [adherencecheckData, setAdherencecheckData] = useState(0);
    const [noOfHeathWorkerData, setNoOfHeathWorkerData] = useState(0);
    const [hcwDropoutData, setHCWDropoutData] = useState(0);
    const [noofParticpantsEnrolledData, setNoofParticpantsEnrolledData] = useState(0);
    const [noofParticpantsDropoutData, setNoofParticpantsDropoutData] = useState([]);
    const [phcWiseData, setPhcWiseData] = useState([]);
    const [noParticipantReferralData, setNoParticipantReferralData] = useState(0);
    const [noPendingBaselineCounsellingF0Data, setNoPendingBaselineCounsellingF0Data] = useState(0);
    const [pendingFollowupsData, setPendingFollowupsData] = useState(0);
    const [completedFollowUpsF0F1F2F3F4Data, setCompletedFollowUpsF0F1F2F3F4Data] = useState(0);
    const [prevelanceMildDepressionData, setPrevelanceMildDepression] = useState([]);
    const [noInterventionsProvidedHCWData, setNoInterventionsProvidedHCWData] = useState(0);



    const getOverall = async () => {
      try {
        setLoading(true);
        const requestData = {
          role_code : roleID,
	        login_user_id : userID,
          state_id : "",
          from_month_id : "",
          to_month_id : "",
          from_year_id : "",
          to_year_id : "",
	        prs_id :"",
	        prs_name :"",
	        phc_type_id : "",
	        phc_type_name :"",
	        phc_id :"",
	        phc_name :"",
	        site_id :"",
	        site_name :"",
          request_table : {
              SiteAdminDashboard : "",
          },
          synceddatetime : "02-07-2025 11:14:18",
          FormCode : "218",
          ApiKey : "kavin",
          AppTypeNo : "3",
          AppVersion : "1.0.0",
          Data_source : "W"
        };
        const result = await api.get_Over_all_Dashboard(requestData);

        const recruitmentData = result?.responsemessage?.SiteAdminDashboard?.[0]?.RecruitmentRate || [];
        const formattedData = recruitmentData.map((item) => ({
          week: `Week ${item.registration_week} (${item.year})`,
          participants: item.participants_enrolled_in_week
        }));

        const suicideModule = result?.responsemessage?.SiteAdminDashboard?.[0]?.ApplicationOfSuicideModule?.[0]?.application_of_suicide_module ?? null;
        const adherenceCheck = result?.responsemessage?.SiteAdminDashboard?.[0]?.AdherenceCheck?.[0]?.adherence_check ?? null;
        const noOfHeathWorker = result?.responsemessage?.SiteAdminDashboard?.[0]?.NoOfHealthWorkersEnrolled?.[0]?.no_of_health_workers_enrolled ?? null;
        const hcwDropout = result?.responsemessage?.SiteAdminDashboard?.[0]?.HcwDropoutRate?.[0]?.dropout_percentage ?? null;
        const noofParticpantsEnrolled = result?.responsemessage?.SiteAdminDashboard?.[0]?.NoOfParticipantsEnrolled?.[0]?.no_of_participants_enrolled ?? null;

        const dropoutDataRaw = result?.responsemessage?.SiteAdminDashboard?.[0]?.NoOfParticipantsDropoutsWithdrawalDropdownMenu || [];
        const noofParticpantsDropout = dropoutDataRaw.map(item => ({
          phcName: item.fld_phc_name,
          total_withdrawals: Number(item.total_withdrawals),
          dropout_phq2: Number(item.dropout_phq2),
          dropout_phq9: Number(item.dropout_phq9),
          lost_f0: Number(item.lost_f0),
          lost_f1: Number(item.lost_f1),
          lost_f2: Number(item.lost_f2),
          lost_f3: Number(item.lost_f3),
          lost_f4: Number(item.lost_f4),
        }));

        const phcData = result?.responsemessage?.SiteAdminDashboard?.[0]?.PhcWiseTotalStudyParticipants || [];
        const formattedPhcData = phcData.map(item => ({
          label: item.phc_id === "Total" ? "Total Participants" : item.phc_id,
          value: item.phc_id === "Total" ? item.total_participant_count : item.total_enrollment_and_assessment
        })).filter(item => item.value !== null);

        const noParticipantReferral = result?.responsemessage?.SiteAdminDashboard?.[0]?.NoOfParticipantsNeedingReferral?.[0]?.no_of_participants_needing_referral ?? null;
        const noPendingBaselineCounsellingF0 = result?.responsemessage?.SiteAdminDashboard?.[0]?.PendingBaselineCounselingF0?.[0]?.pending_baseline_counseling_f0 ?? null;
        const pendingFollowups = result?.responsemessage?.SiteAdminDashboard?.[0]?.PendingFollowUps?.[0]?.pending_f0_counselling ?? null;
        const completedFollowUpsF0F1F2F3F4 = result?.responsemessage?.SiteAdminDashboard?.[0]?.CompletedFollowUpsF0F1F2F3F4?.[0]?.completed_follow_ups_f0_f1_f2_f3_f4 ?? null;
        const prevelanceMildDepression = result?.responsemessage?.SiteAdminDashboard?.[0]?.PrevalenceOfMildDepression?.[0]?.prevalence_mild_depression_percentage ?? null;
        const noInterventionsProvidedHCW = result?.responsemessage?.SiteAdminDashboard?.[0]?.TotalNoOfInterventionsProvidedByHCW?.[0]?.total_interventions_provided_by_hcw ?? null;



        setRecruitmentRateData(formattedData);
        setSuicideModuleData(suicideModule);
        setAdherencecheckData(adherenceCheck);
        setNoOfHeathWorkerData(noOfHeathWorker);
        setHCWDropoutData(hcwDropout);
        setNoofParticpantsEnrolledData(noofParticpantsEnrolled);
        setNoofParticpantsDropoutData(noofParticpantsDropout);
        setPhcWiseData(formattedPhcData);
        setNoParticipantReferralData(noParticipantReferral);
        setNoPendingBaselineCounsellingF0Data(noPendingBaselineCounsellingF0);
        setPendingFollowupsData(pendingFollowups);
        setCompletedFollowUpsF0F1F2F3F4Data(completedFollowUpsF0F1F2F3F4);
        setPrevelanceMildDepression(prevelanceMildDepression);
        setNoInterventionsProvidedHCWData(noInterventionsProvidedHCW);

      } catch (error) {
        console.error("Error fetching site:", error);
      }  finally {
        setLoading(false);
    }
    };

    useEffect(() => {
      getOverall();
    }, []);



    const formik = useFormik({
    initialValues: {
      site_name:"",
      taluk_name:"",
      prs_name:"",
      village_name:"",
      phc_name:"",
      phc_type_name:""
    },
    validationSchema: Yup.object({
      site_name: Yup.string().required("Site Code is required"),
      taluk_name: Yup.string().required("Taluk Name is required"),
      prs_name: Yup.string().required("PRS Name is required"),
      village_name: Yup.string().required("Village Name is required"),
      phc_name: Yup.string().required("PHC Name is required"),
      phc_type_name: Yup.string().required("PHC Type is required"),


    }),

    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const additionalData = {
          // state_id: selectedState?.state_code || "",
          state_id: values.state_code,
          district_id: values.district_code,
          site_id: values.site_code,
          taluk_id: values.taluk_code,
          fld_mapped_prs_id: values.prs_userID,
          village_id: values.village_code,
          phc_name: values.phc_name,
          phc_type_name: values.phc_type_name,
          phc_type_id: values.phc_type_id,
          synceddatetime: formattedCurrentDate,
          FormCode: "202",
          ApiKey: "kavin",
          AppTypeNo: "3",
          AppVersion: "1.0.0",
          data_source: "W",
          loggedin_user_id: userID,
        };

        const response = await api.add_PHC(additionalData);

        if (response && response.status === "1") {
          toast.current.show({
            severity: "success",
            summary: "PHC Created Successful",
            detail:
              response.responsemessage ||
              "You have successfully created the PHC.",
          });
          resetForm();
        } else {
          throw new Error(
            response
              ? response.responsemessage ||
                "An error occurred while creating the PHC."
              : "No response from the server."
          );
        }
      } catch (error) {
        console.error("PHC submission error:", error);

        toast.current.show({
          severity: "error",
          summary: " PHC Failed",
          detail:
            error.message || "An unexpected error occurred. Please try again.",
        });
      } finally {
        setLoading(false);
    }
    },
    });

  return (
    <div>
        {loading && (
            <div className="backdrop">
                <ProgressSpinner style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
            </div>
        )}
        {/* <div className='flex justify-content-between align-items-center'>
            <Dropdown
               id="site_name"
               name="site_name"
               placeholder="Select Site"
               value={formik.values.site_name}
               className= "dashboard-dropdown-filter"
               options={site}
               disabled={roleID === "2"}
               onChange={(e) => {
                 const selectedSite = site.find(
                   (siteObj) => siteObj.value === e.value
                 );
                 setSelectedSite(selectedSite);
                 formik.setFieldValue("site_name", e.value);
                 if (selectedSite) {
                   formik.setFieldValue("site_code", selectedSite.site_code || "");
                   formik.setFieldValue("site_sw_id", selectedSite.site_swid || "");
                 } else {
                   formik.setFieldValue("site_code", "");
                   formik.setFieldValue("site_sw_id", "");
                   setSite([]);
                 }
               }}
            />

            <Dropdown
              id="phc_type_name"
              name="phc_type_name"
              placeholder="Select PHC Type"
              className= "dashboard-dropdown-filter"
              options={typeName}
              value={selectedType}
              onChange={(e) => {
                const selectedType = e.value;
                formik.setFieldValue("phc_type_id", selectedType.id);
                formik.setFieldValue("phc_type_name", selectedType.label);
                setSelectedType(selectedType);
              }}
            />

            <Calendar
               id="fld_from_month_name"
               name="fld_from_month_name"
               placeholder="Enter Month & Year"
               value={date}
               showButtonBar={!!date}
               className= "dasboardCalendar"
               onChange={(e) => {
                if (!e.value) {
                    // Clear the month/year fields when the calendar is cleared
                    setDate(null);
                    formik.setFieldValue("from_year_id", "");
                    formik.setFieldValue("from_month_id", "");
                    formik.setFieldValue("fld_from_month_name", "");
                } else {
                    setDate(e.value);
                    const selectedDate = new Date(e.value);
                    const selectedMonthid = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
                    const selectedYear = selectedDate.getFullYear();
                    formik.setFieldValue("from_year_id", selectedYear);
                    formik.setFieldValue("from_month_id", selectedMonthid);
                    formik.setFieldValue("fld_from_month_name", e.value);
                }
            }}
               dateFormat="mm/yy"
               view="month"
               showIcon
               onBlur={formik.handleBlur}
               maxDate={new Date()}
           />
            <Calendar
              id="fld_to_month_name"
              name="fld_to_month_name"
              placeholder="Enter Month & Year"
              value={date1}
              showButtonBar={!!date1} 
              className= "dasboardCalendar"
              onChange={(e) => {
                if (!e.value) {
                    setDate1(null);
                    formik.setFieldValue("to_year_id", "");
                    formik.setFieldValue("to_month_id", "");
                    formik.setFieldValue("fld_to_month_name", "");
                } else {
                    setDate1(e.value);
                    const selectedDate = new Date(e.value);
                    const selectedMonthid = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
                    const selectedYear = selectedDate.getFullYear();
                    formik.setFieldValue("to_year_id", selectedYear);
                    formik.setFieldValue("to_month_id", selectedMonthid);
                    formik.setFieldValue("fld_to_month_name", e.value);
                }
            }}
              dateFormat="mm/yy"
              view="month"
              showIcon
              onBlur={formik.handleBlur}
              maxDate={new Date()}
          />

            <div>
           <Button className="filterFormbutton" type="submit" label='View'/>
           <Button className="filterClearButton" type="button"  label="Clear"
            severity="danger" outlined  />
            </div>

        </div> */}



        <h3 className='mt-0 mb-0'> PRS </h3>
        <div className='grid m-0 mt-2 gap-2'>
          <div className='col-3 layout'>
            <h2 className="m-0">{suicideModuleData}</h2>
            <p className="pr-4 dashboardText">Application of suicide module</p>
          </div>
          <div className='col-3 layout'>
            <h2 className="m-0">{adherencecheckData}</h2>
            <p className="pr-4 dashboardText">Adherence check</p>
          </div>
        </div>

        <div className='mt-5 layout'>
        <h4 className='mb-4 mt-0'>Recuitment rate</h4>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={recruitmentRateData}>
            <CartesianGrid strokeDasharray="3 3"  vertical={false} />
            <XAxis dataKey="week" style={{fontSize:"12px"}}/>
            <YAxis style={{fontSize:"12px"}}/>
            <Tooltip />
            <Legend style={{color:"#808080"}} wrapperStyle={{ fontSize: "12px" }}/>
            <Line type="monotone" dataKey="participants" stroke="#8884d8" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
        </div>


        <h3 className='mt-5 mb-0'> PHC </h3>
        <div className='grid m-0 mt-2 gap-2'>
          <div className='col layout'>
            <h2 className="m-0">{noOfHeathWorkerData}</h2>
            <p className="pr-4 dashboardText">No of Health Worker Enrolled</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{hcwDropoutData} %</h2>
            <p className="pr-4 dashboardText">HCW dropout rate</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{noofParticpantsEnrolledData}</h2>
            <p className="pr-4 dashboardText">No of Particpants Enrolled</p>
          </div>
        </div>

        <div className='mt-5 layout'>
          <h4 className='mb-4 mt-0'>PHC-wise Dropouts and Withdrawals</h4>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={noofParticpantsDropoutData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="phcName" style={{ fontSize: "12px" }} />
              <YAxis style={{ fontSize: "12px" }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: "12px" }}/>
              <Bar dataKey="total_withdrawals" stackId="a" fill="#8884d8" />
              <Bar dataKey="dropout_phq2" stackId="a" fill="#82ca9d" />
              <Bar dataKey="dropout_phq9" stackId="a" fill="#ffc658" />
              <Bar dataKey="lost_f0" stackId="a" fill="#ff7f50" />
              <Bar dataKey="lost_f1" stackId="a" fill="#a569bd" />
              <Bar dataKey="lost_f2" stackId="a" fill="#f39c12" />
              <Bar dataKey="lost_f3" stackId="a" fill="#16a085" />
              <Bar dataKey="lost_f4" stackId="a" fill="#c0392b" />
            </BarChart>
          </ResponsiveContainer>
        </div>


        <h3 className='mt-5 mb-0'>PHC wise total study participants</h3>
        <div className='mt-2 layout'>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={phcWiseData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="label" style={{ fontSize: "12px" }} />
              <YAxis style={{ fontSize: "12px" }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: "12px" }}/>
              <Bar dataKey="value" fill="#82ca9d" barSize={30} />
            </BarChart>
          </ResponsiveContainer>
        </div>

      <Divider/>
        <div className='grid m-0 mt-2 gap-2'>
          <div className='col layout'>
            <h2 className="m-0">{noParticipantReferralData}</h2>
            <p className="pr-4 dashboardText">No of Participant needing Referral</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{noPendingBaselineCounsellingF0Data}</h2>
            <p className="pr-4 dashboardText">Pending Baseline Counselling (F0)</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{pendingFollowupsData}</h2>
            <p className="pr-4 dashboardText">Pending Follow-ups</p>
          </div>
        </div>

        <div className='grid m-0 mt-2 gap-2'>
          <div className='col layout'>
            <h2 className="m-0">{completedFollowUpsF0F1F2F3F4Data}</h2>
            <p className="pr-4 dashboardText">Completed Follow-ups (F0, F1, F2, F3, F4)</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{Number(prevelanceMildDepressionData).toFixed(0)}</h2>
            <p className="pr-4 dashboardText">Prevelance of mild depression</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{noInterventionsProvidedHCWData}</h2>
            <p className="pr-4 dashboardText">Total No of Interventions Provided by HCW</p>
          </div>
        </div>
    </div>
  )
}

export default Overall